// Lines come from tags, not layout (innerText), so an element has the same name at every screen size
const BLOCK_TAGS = new Set([
  'address',
  'article',
  'aside',
  'blockquote',
  'dd',
  'details',
  'dialog',
  'div',
  'dl',
  'dt',
  'fieldset',
  'figcaption',
  'figure',
  'footer',
  'form',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'header',
  'hr',
  'li',
  'main',
  'nav',
  'ol',
  'p',
  'pre',
  'section',
  'summary',
  'table',
  'td',
  'th',
  'tr',
  'ul',
]);

const IGNORED_TAGS = new Set(['noscript', 'script', 'style', 'svg', 'template']);

const collapseWhitespace = (text: string) => text.replace(/\s+/g, ' ').trim();

const collectLines = (node: Node, lines: string[]) => {
  if (node.nodeType === Node.TEXT_NODE) {
    lines[lines.length - 1] += node.textContent ?? '';

    return;
  }

  if (!(node instanceof Element) || IGNORED_TAGS.has(node.localName)) {
    return;
  }

  if (node.localName === 'br') {
    lines.push('');

    return;
  }

  const isBlock = BLOCK_TAGS.has(node.localName);

  if (isBlock) {
    lines.push('');
  }

  node.childNodes.forEach((child) => collectLines(child, lines));

  if (isBlock) {
    lines.push('');
  }
};

const getFirstLine = (element: Element) => {
  const lines = [''];

  collectLines(element, lines);

  return lines.map(collapseWhitespace).find(Boolean);
};

const getImageAlt = (element: Element) => [...element.querySelectorAll('img')].map((image) => collapseWhitespace(image.alt)).find(Boolean);

export const getElementName = (element: Element, elementLabel = '') =>
  collapseWhitespace(elementLabel) || getFirstLine(element) || getImageAlt(element) || '';
